import { createSlice } from '@reduxjs/toolkit'
import { fetchCargoPackageById, putCargoById } from './thunk'

const initialState = {
  cargoPackageDetails: {},
  cargoPackageDetailsLoading: false,
  cargoPackageError: undefined,

  putCargoByIdLoading: false,
  putCargoByIdError: null,

  selectedCargo: {},
}

const slice = createSlice({
  name: 'cargoPackage',
  initialState,
  reducers: {
    setSelectedCargo: (state, { payload }) => {
      state.selectedCargo = payload
    },
  },
  extraReducers: {
    [fetchCargoPackageById.pending]: (state) => {
      state.cargoPackageDetailsLoading = true
    },
    [fetchCargoPackageById.fulfilled]: (state, { payload }) => {
      state.cargoPackageDetails = payload
      state.cargoPackageDetailsLoading = false
    },
    [fetchCargoPackageById.rejected]: (state, { payload }) => {
      state.cargoPackageDetailsLoading = false
      state.cargoPackageError = payload
    },
    [putCargoById.pending]: (state) => {
      state.putCargoByIdLoading = true
    },
    [putCargoById.fulfilled]: (state, { payload }) => {
      state.putCargoByIdLoading = false
      state.cargo = payload
    },
    [putCargoById.rejected]: (state, { error }) => {
      state.putCargoByIdLoading = false
      state.putCargoByIdError = error
    },
  },
})

export const { setSelectedCargo } = slice.actions

export const reducer = slice.reducer
export const selectorCargoPackage = (state) => state[slice.name]

export default slice
